// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jkp42","image":"styles_image__8W+7m","singleslide":"styles_singleslide__D8PE7","splide__pagination":"styles_splide__pagination__ePuge"};